// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of, Subscription } from 'rxjs';

// --- HS Code
import { TeamEnquiryBaseService } from './team-enquiry-base.service';
import { TeamEnquiryModel } from '../../../models/team/team-enquiry-model';
import { TeamEnquiryResult } from '../../../models/team/team-enquiry-result';
import { delay, map } from 'rxjs/operators';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class TeamEnquiryMockService extends TeamEnquiryBaseService {

  private _sendSubscription: Subscription;

  constructor() {
    super();
  }

  clearState(): void {
    this._isSending$.next(false);
    this._isSent$.next(false);
    this._enquiryError$.next(null);
    this._enquiryResult$.next(null);
  }

  sendEnquiry(model: TeamEnquiryModel): void {
    this._isSending$.next(true);
    this._enquiryError$.next(null);

    this._sendSubscription = of(model).pipe(
      delay(5000),
      map((): TeamEnquiryResult => {
        return {};
      })
    ).subscribe((response) => {
      this._enquiryResult$.next(response);
      this._isSending$.next(false);
      this._isSent$.next(true);
    });

    this.hideEnquiryForm();
  }

}
